import { useAccount } from '../account/store.ts';
import { plural } from '../lib/format.ts';
import { services } from '../services/index.ts';
import { ask, toast } from '../state/feedback.ts';
import { db } from '../storage/db.ts';
import { canSyncScope } from '../sync/service.ts';

/** Guest → account: offer to back up projects that exist only on this device. */
export async function offerBackup(): Promise<void> {
  const me = useAccount.getState().me;
  if (!me || !canSyncScope(me.personalScope)) return;
  const tracked = new Set((await db().projectSync.toArray()).map((r) => r.id));
  const local = (await db().projects.toArray()).filter((p) => !tracked.has(p.id));
  if (local.length === 0) return;
  const ok = await ask({
    title: `Back up ${plural(local.length, 'project')} to your account?`,
    message: 'They’ll sync to your other devices. They stay on this device either way.',
    actions: [
      { label: 'Back Up', value: true, variant: 'primary' },
      { label: 'Not Now', value: false, variant: 'ghost' },
    ],
  });
  if (!ok) return;
  await services.sync.backup(
    local.map((p) => p.id),
    me.personalScope,
  );
  toast('Backing up your projects…');
}
